import { useQuery, QueryHookOptions } from '@apollo/client'
import { DocumentNode } from 'graphql'
import { ChatscriptConversation } from '@babylon/graphql-middleware-types'

export default function useQueryConversations(
  query: DocumentNode,
  userId: string,
  type?: string | null,
  options: Pick<QueryHookOptions, 'skip'> = {}
) {
  const { error, data, loading, fetchMore } = useQuery(query, {
    variables: {
      userId,
      order: 'desc',
      limit: 20,
      offset: 0,
      type,
    },
    ...options,
  })

  const covidConversations = data?.chatscriptConversations?.conversations || []

  const normalisedConversation = covidConversations.map(
    (conversation: ChatscriptConversation) => ({
      id: conversation?.id,
      time: conversation?.startedAt,
      text: conversation?.preview,
      tag: conversation?.result?.type,
      type: conversation?.type,
      userUuid: conversation?.userUuid,
      patientUuid: conversation?.patientUuid,
    })
  )

  const fetchMoreConversations = () =>
    fetchMore({
      variables: {
        userId,
        order: 'desc',
        limit: 20,
        type,
        offset: data?.chatscriptConversations?.conversations.length,
      },
      updateQuery: (prev: any, { fetchMoreResult }: any) => {
        const prevConversations = prev.chatscriptConversations.conversations
        const nextConversations =
          fetchMoreResult.chatscriptConversations.conversations

        return {
          chatscriptConversations: {
            ...prev.chatscriptConversations,
            more: fetchMoreResult.chatscriptConversations.more,
            conversations: [...prevConversations, ...nextConversations],
          },
        }
      },
    })

  return {
    data: normalisedConversation,
    loading,
    error,
    more: data?.chatscriptConversations?.more,
    fetchMore: fetchMoreConversations,
  }
}
